module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-container sendi-admin-entry"
  }, [_c('div', {
    staticClass: "d-content select-login"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "f"
  }, [_c('div', {
    staticClass: "f-content",
    on: {
      "click": _vm.toAdminLogin
    }
  }, [_c('div', {
    staticClass: "h"
  }, [_c('div', {
    staticClass: "f-data-icon",
    attrs: {
      "id": "administrador"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "buttom-f text-center"
  }, [_c('button', {
    class: 'btn btn-primary  btn-block btn-round btn-welcome ',
    attrs: {
      "type": "button",
      "id": "admin-access",
      "aria-label": "Acceder como administrador"
    }
  }, [_vm._v("Continuar")])])])]), _vm._v(" "), _c('div', {
    staticClass: "f-content",
    on: {
      "click": _vm.toOperLogin
    }
  }, [_c('div', {
    staticClass: "h"
  }, [_c('div', {
    staticClass: "f-data-icon",
    attrs: {
      "id": "operador-envio"
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "buttom-f text-center"
  }, [_c('button', {
    class: 'btn btn-primary  btn-block btn-round btn-welcome ',
    attrs: {
      "type": "button",
      "id": "operator-access",
      "aria-label": "Acceder como operador de envío o recepción"
    }
  }, [_vm._v("Continuar")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-header text-center"
  }, [_c('span', {
    staticClass: "title-login"
  }, [_c('img', {
    staticClass: "logo-login",
    attrs: {
      "src": "/static/img/sendi-logo.png",
      "width": "400",
      "height": "78",
      "alt": "Sendi"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "sendi-admin-title"
  }, [_vm._v("Portal de administración")]), _c('p', {
    staticClass: "sub-login"
  }, [_vm._v("Selecciona el tipo de usuario")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "f-data-text"
  }, [_c('p', [_vm._v("Administrador")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "f-data-text"
  }, [_c('p', [_vm._v("Operador de envío/recepción")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0de2c3bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginSelection.vue
// module id = 1849
// module chunks = 1